import { useEffect, useMemo, useState, useRef } from 'react'
import {
  Mask,
  Popover,
  Arrow,
  HelpMask,
  StepOneBox,
  StepTitle,
  StepIntro,
  StepLink,
  Close,
  StepFooter,
  StepNextButton,
  StepHeader,
} from './styles'
import { debounce } from 'lodash'
import {
  getDomRectPos,
  ELEMENT_ID_LIST,
  bringInView,
  getElement,
  LINK,
} from './uitls'
import dayjs from 'dayjs'

import ContentPNG from './assets/content.png'
import { updateModal } from 'store/app/actions/modalActions'
import { useDispatch } from 'react-redux'
import { useAccountInfo, useAccountTickets } from 'store/account/hooks'
import { ActivateStatus } from 'api/v1/account'
import { updateGuideText } from 'store/app/actions'

interface IAnchor {
  top: number
  left: number
  bottom: number
  width: number
  height: number
  right: number
  centerX: number
  centerY: number
}

export const AccountActiveDayGuide = () => {
  const [anchorRectPosList, setAnchorRectPosList] = useState<IAnchor[]>([])
  const [step, setStep] = useState(0)
  const [showGuide, setShowGuide] = useState(false)
  const dispatch = useDispatch()
  const accountInfo = useAccountInfo()
  const tickets = useAccountTickets()
  const timer = useRef<any>()

  const handleClose = () => {
    localStorage.setItem(
      'zkex_v3_day_open_account_guide',
      dayjs().format('YYYYMMDD'),
    )
    setShowGuide(false)
  }

  // useEffect(() => {
  //   if (!showGuide) {
  //     localStorage.setItem(
  //       'zkex_v3_day_open_account_guide',
  //       dayjs().format('YYYYMMDD'),
  //     )
  //   }
  // }, [showGuide])

  useEffect(() => {
    const guideDate = localStorage.getItem('zkex_v3_day_open_account_guide')
    const accountGuide = localStorage.getItem('zkex_v3_open_account_guide')
    let alreadyOpen = false
    if (dayjs().format('YYYYMMDD') === guideDate) {
      alreadyOpen = true
    }
    if (
      ((accountInfo && accountInfo?.status === ActivateStatus.INACTIVE) ||
        (tickets === undefined && Object.keys(accountInfo).length === 0)) &&
      !alreadyOpen &&
      accountGuide === '1'
    ) {
      timer.current = setTimeout(() => {
        setShowGuide(true)
      }, 2000)
    } else {
      clearTimeout(timer.current)
      setShowGuide(false)
    }
  }, [accountInfo, tickets])

  const handleCalcElemntsPos = () => {
    const list: Array<IAnchor> = []
    try {
      ELEMENT_ID_LIST.forEach((id) => {
        const dom = getElement(id) as HTMLElement
        if (dom) {
          const style = getDomRectPos(dom)
          list.push(style)
        } else {
          throw new Error(`id: ${id} dom dose not exit`)
        }
      })
      setAnchorRectPosList(list)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    const nav_wrap = getElement('zk_nav_wrap') as HTMLElement
    const spot_wrap = (getElement('zk_spot_wrap') ||
      getElement('zk_perp_wrap')) as HTMLElement

    if (showGuide) {
      nav_wrap.style.position = 'relative'
      spot_wrap.style.padding = '0px 0px 24px'
      dispatch(updateGuideText('Open My Account'))
    } else {
      nav_wrap.style.position = 'fixed'
      spot_wrap.style.padding = '64px 0 24px'
      dispatch(updateGuideText(''))
    }
  }, [showGuide])

  // realtime computing position
  useEffect(() => {
    const debouncedHandle = debounce(handleCalcElemntsPos)
    window.addEventListener('resize', debouncedHandle, false)
    return () => window.removeEventListener('resize', debouncedHandle)
  }, [])

  useEffect(() => {
    const nav_wrap = getElement('zk_nav_wrap') as HTMLElement
    const spot_wrap = (getElement('zk_spot_wrap') ||
      getElement('zk_perp_wrap')) as HTMLElement
    setTimeout(() => {
      handleCalcElemntsPos()
    }, 500)
    return () => {
      nav_wrap.style.position = 'fixed'
      spot_wrap.style.padding = '64px 0 24px'
    }
  }, [])

  const stepRectPos = useMemo(() => {
    if (anchorRectPosList.length > 0) {
      return anchorRectPosList[step] as IAnchor
    }
    // @ts-ignore
    return {} as IAnchor
  }, [anchorRectPosList, step])

  useEffect(() => {
    bringInView(ELEMENT_ID_LIST[step])
  }, [stepRectPos, step])

  const CloseBtn = () => {
    return <Close onClick={() => handleClose()} />
  }

  const renderStepButton = () => {
    return (
      <StepFooter>
        <StepNextButton
          onClick={() => {
            handleClose()
          }}
        >
          No Thanks
        </StepNextButton>

        <StepNextButton
          className="finished"
          onClick={() => {
            handleClose()
            dispatch(updateModal({ modal: 'guide', open: true }))
          }}
        >
          Open My Account
        </StepNextButton>
      </StepFooter>
    )
  }

  // Guide Steps
  const GUIDE_STEPS = [
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top - 250, left: currRectPos.left - 360 }}
          >
            <Arrow className="right" style={{ top: '250px' }}></Arrow>

            <StepOneBox>
              <StepHeader>
                <StepTitle>Open Your Account</StepTitle>
                <StepIntro>
                  <CloseBtn />
                </StepIntro>
              </StepHeader>

              <img src={ContentPNG} style={{ marginTop: '16px' }} alt="" />
              <StepLink
                href={LINK[0]}
                target="_blank"
                style={{ marginLeft: '28px' }}
              >
                Learn more about how ZKEX works
              </StepLink>
              {renderStepButton()}
            </StepOneBox>
          </Popover>
        )
      },
    },
  ]

  const maskHeight = (document.querySelector('#root') as HTMLElement)
    .clientHeight
  return (
    <>
      {showGuide && (
        <Mask height={maskHeight}>
          {step >= 0 && stepRectPos.width > 0 && (
            <HelpMask
              style={{
                width: stepRectPos.width,
                height: stepRectPos.height,
                left: stepRectPos.left,
                top: stepRectPos.top,
              }}
            ></HelpMask>
          )}
        </Mask>
      )}

      {stepRectPos?.width >= 0 &&
        showGuide &&
        GUIDE_STEPS[step]?.popover(stepRectPos)}
    </>
  )
}
